export const search = {
	className: 'icon-search',
	viewBox: '0 0 196.78101 196.78101',
	paths: ['M 196.781,186.896 133.739,123.847 C 144.628,110.745 151.196,93.93 151.196,75.598 151.196,33.918 117.285,0 75.598,0 33.91,0 0,33.917 0,75.598 c 0,41.681 33.91,75.598 75.598,75.598 18.331,0 35.153,-6.568 48.255,-17.464 l 63.042,63.049 9.886,-9.885 z M 13.982,75.598 c 0,-33.979 27.644,-61.615 61.616,-61.615 33.972,0 61.615,27.636 61.615,61.615 0,33.979 -27.644,61.616 -61.615,61.616 -33.972,0 -61.616,-27.636 -61.616,-61.616 z']
}
